import { isBefore } from 'date-fns';
import { z } from 'zod';

export const getCustomerMessageOptions = (measurementGroupName: string) => {
	return [
		`Field maintenance is required at ${measurementGroupName}`,
		'Field maintenance is complete and our estimate is flowing again.',
		`We have recalibrated ${measurementGroupName}`,
		'Custom message'
	] as const;
};

export const getMeasurementGroupStatusForm = (measurementGroupName: string) => {
	const customerMessageOptions = getCustomerMessageOptions(measurementGroupName);

	return z
		.object({
			statusId: z.string().min(1, {
				message: 'Status is required'
			}),
			internalMessage: z.string().optional(),
			customerMessage: z.enum(customerMessageOptions, {
				message: 'Please select a valid customer message'
			}),
			additionalCustomerMessage: z.string().optional(),
			startDate: z.date().optional(),
			returnDate: z.date().optional()
		})
		.refine(
			data => {
				if (data.customerMessage === customerMessageOptions[3]) {
					return !!data.additionalCustomerMessage?.trim();
				}
				return true;
			},
			{
				message: 'Additional customer message is required',
				path: ['additionalCustomerMessage']
			}
		)
		.refine(
			data => {
				if (data.returnDate && data.startDate) {
					return isBefore(data.startDate, data.returnDate);
				}
				return true;
			},
			{
				message: 'Return date cannot be before start date',
				path: ['returnDate']
			}
		)
		.refine(
			data => {
				if (data.startDate) {
					return isBefore(new Date(), data?.startDate);
				}
				return true;
			},
			{
				message: 'Start date cannot be in the past',
				path: ['startDate']
			}
		);
};

export type MeasurementGroupStatusFormType = z.infer<ReturnType<typeof getMeasurementGroupStatusForm>>;
